import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getRegistrationStatus } from '../../services/api';

const STATUS_LABEL = {
  pending: { text: '付款處理緊...', color: 'text-yellow-600', icon: '⏳' },
  confirmed: { text: '報名成功!', color: 'text-green-600', icon: '✅' },
  failed: { text: '付款失敗', color: 'text-red-600', icon: '❌' },
  cancelled: { text: '已取消', color: 'text-gray-500', icon: '🚫' },
  expired: { text: '逾時未付款', color: 'text-red-600', icon: '⌛' },
};

const TERMINAL_STATUSES = ['confirmed', 'failed', 'cancelled', 'expired'];
const POLL_INTERVAL_MS = 2000;
const MAX_POLLS = 30; // 30 x 2s = 1 分鐘,綠界 ReturnURL 通常好快到,唔會等太耐

// 呢頁本身唔係付款結果嘅依歸(見 backend events/views.py::ecpay_callback 嘅
// comment)——用戶去到呢度可能仲未收到綠界 server-to-server 嘅 callback,
// 所以要 poll registration_status,直到見到真正確定咗嘅狀態先顯示。
const EventResult = () => {
  const [searchParams] = useSearchParams();
  const registrationId = searchParams.get('registration_id');
  const [registration, setRegistration] = useState(null);
  const [pollCount, setPollCount] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!registrationId) return;

    const poll = async () => {
      try {
        const res = await getRegistrationStatus(registrationId);
        setRegistration(res.data);
        if (TERMINAL_STATUSES.includes(res.data.status)) {
          clearInterval(intervalRef.current);
        }
      } catch (err) {
        clearInterval(intervalRef.current);
      }
      setPollCount((c) => c + 1);
    };

    poll();
    intervalRef.current = setInterval(poll, POLL_INTERVAL_MS);
    return () => clearInterval(intervalRef.current);
  }, [registrationId]);

  useEffect(() => {
    if (pollCount >= MAX_POLLS) clearInterval(intervalRef.current);
  }, [pollCount]);

  if (!registrationId) {
    return <div className="max-w-md mx-auto p-6 text-center text-gray-500">找不到報名記錄</div>;
  }

  const status = registration?.status || 'pending';
  const label = STATUS_LABEL[status] || STATUS_LABEL.pending;
  const stillPolling = !TERMINAL_STATUSES.includes(status) && pollCount < MAX_POLLS;

  return (
    <div className="max-w-md mx-auto p-6 bg-gray-50 min-h-screen pb-24 flex flex-col items-center justify-center text-center">
      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 w-full">
        <div className="text-5xl mb-4">{label.icon}</div>
        <h1 className={`text-2xl font-black mb-2 ${label.color}`}>{label.text}</h1>

        {registration && (
          <div className="text-sm text-gray-500 space-y-1 mt-4">
            <p>{registration.event_name}</p>
            <p>{registration.contact_name} · {registration.num_participants} 人</p>
            {registration.payment && <p>NT${registration.payment.amount}</p>}
          </div>
        )}

        {stillPolling && (
          <p className="text-xs text-gray-400 mt-6">正在確認付款結果,請稍候...</p>
        )}

        {status === 'expired' || status === 'failed' ? (
          <p className="text-xs text-gray-400 mt-6">如果已經扣款但顯示失敗,請聯絡我們核實。</p>
        ) : null}
      </div>
    </div>
  );
};

export default EventResult;
